import React from "react";
import { StyleSheet } from "react-native";
import { globalStyle } from "../../../assets";
import CommonModal from "../../../commonComponents/commonModal";
import { isMobile } from "../../../utils/commonMethods";
import {globalConfigurableData} from "../../../utils/globalConstant";

const TripleAWebView = ({
  htmlLink,
  setHtmlLink,
  navigation,
  watchamount,
  setTxnStatus,
}) => {
  return (
    <CommonModal
      isOpen={htmlLink !== null}
      customModalStyle={[
        isMobile() ? globalStyle.modalView : styles.modalStyle,
      ]}
      onModalCallBack={() => {
        setHtmlLink(null);

        var a = {
          isShow: true,
          status: false,
          amount: watchamount,
          msg: "Your deposit is failed. Please try again",
          title: "Payment Failed!",
          // disclaimer: "",
          isDeposit: true,
        };
        if (isMobile()) {
          navigation.push("WalletStack", {
            screen: "WalletStatus",
            params: { paymentStatus: a },
          });
        } else {
          setTxnStatus({ paymentStatus: a });
        }
      }}
    >
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <iframe
          id="triplea-payment-form"
          src={htmlLink}
          style={{
            width: window.width,
            height: "600px",
            border: "0",
          }}
        ></iframe>
      </div>
    </CommonModal>
  );
};
export default TripleAWebView;

const styles = StyleSheet.create({
  modalStyle: {
    position: "absolute",
    alignItems: "center",
    borderRadius: 8,
    elevation: 6,
    backgroundColor: globalConfigurableData.cardBgColor
  },
});
